import { travel, axiosConfig } from 'api';

import { AirlineResponse, Airline, AirlinesExcludedRequest } from 'models/airlineException';
import { Response } from 'models/response';

export const fetchAirlinesDeleted = (companyId: string) =>
  travel.get<Response<AirlineResponse[]>>('DeletedAirline/GetAllDeletedAirlinesByCompany', axiosConfig);

export const fetchAllAirlines = () => travel.get<Response<Airline[]>>('Airline/GetAllAirlines', axiosConfig);

export const doSaveExcludedAirlines = (data: AirlinesExcludedRequest) =>
  travel.post('DeletedAirline/Create', { ...data });

export const doDeleteAirline = (airlineId: string) => travel.delete(`DeletedAirline/${airlineId}`);
